export default class User{
    static path(){
        return '/api/users/';
    }

    constructor(data){
        this.originalData = data;
        this.extract(data);

        // Back Set the current User Role.
        this.originalData.role = this.currentRole();
    }

    refresh() {
        window.axios.get(this.path() + this.id).then(res => {
            this.extract(res.data);
        });
    }

    can(permission) {
        if (typeof this['has_permissions'] === 'undefined') {
            return false;
        }
        
        return this['has_permissions'].indexOf(permission) > -1;
    }

    currentRole() {
        if (typeof this.has_roles === 'undefined') { return '' }

        return this.has_roles[0] || '';
    }

    extract(data){
        for (let field in data) {
            this[field] = data[field];
        }
        this.role = this.currentRole();
    }
}